var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarDays = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 97,
  height: 96,
  viewBox: "0 0 97 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M78.6812 13.0913H17.5903C12.7704 13.0913 8.86304 16.9986 8.86304 21.8186V82.9095C8.86304 87.7294 12.7704 91.6368 17.5903 91.6368H78.6812C83.5012 91.6368 87.4085 87.7294 87.4085 82.9095V21.8186C87.4085 16.9986 83.5012 13.0913 78.6812 13.0913Z",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M65.5906 4.36377V21.8183",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6814 4.36377V21.8183",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.86304 39.2725H87.4085",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6814 56.7275H30.725",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M48.1355 56.7275H48.1791",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M65.5906 56.7275H65.6342",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6814 74.1821H30.725",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M48.1355 74.1821H48.1791",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M65.5906 74.1821H65.6342",
  stroke: "#4585FF",
  strokeWidth: 3.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgCalendarDays;